module.exports = __webpack_public_path__ + "img/user-minus-01.2d0724b2.svg";